<template>
    <div class="btns">
        <router-link
            v-if="prev"
            class="btn"
            :to="{name: prev}"
        >
            {{ 'shopcart.back' | trans }}
        </router-link>
        <router-link
            v-if="next"
            class="btn"
            :to="{name: next}"
            :disabled="redirect"
        >
            {{ 'shopcart.next' | trans }}
        </router-link>
        <button
            v-if="hasPayment"
            class="btn"
            form="vue-form"
            @click.prevent="save"
        >
            {{ `shopcart.${type}` | trans }}
        </button>
    </div>
</template>

<script>

import LocaleStorage from 'local-storage';
import { reject, isNil, hasIn } from 'ramda';
import { breadcrumb } from '../router/index';

const api = window.groovie.api;
const baseUrl = api.base;
const cart = `${baseUrl}/${api.client}`;

const cleanData = hasIn('clean_data', window.groovie) ? window.groovie.clean_data : false;
const storage = hasIn('storage_prefix', window.groovie) ? `${window.groovie.storage_prefix}_` : '';

export default {
    name: 'actions',
    props: {
        hasPayment: {
            type: Boolean,
            default: false
        },
        redirect: {
            type: Boolean,
            required: true
        },
        data: {
            type: Object,
            default: () => ({
                    name: '',
                    lastName: '',
                    phone: '',
                    email: '',
                    address: '',
                    city: '',
                    country: '',
                    postal: '',
                    observations: '',
                    payment: ''
                })
        }
    },
    computed: {
        prev() {
            const result = this.route(false);
            return result;
        },
        next() {
            const result = this.route(true);
            return result;
        },
        type() {
            let type = 'pay';
            if (this.$route.name === 'fail') {
                type = 'retry';
            }

            if (!isNil(this.data.payment.type) && this.data.payment.type === 'cash') {
                type = 'end';
            }
            return type;
        }
    },
    methods: {
        route(next = true) {
            let actual = this.$route.name;

            if (actual === 'fail') {
                actual = 'check';
            }

            const links = reject(value => value === 'icon_next', breadcrumb);
            const index = links.indexOf(actual);

            if (next && index < links.length && this.redirect) {
                return links[index + 1];
            } else if (!next && index > 0) {
                return links[index - 1];
            }
            return false;
        },
        save() {
            this.$groovie
                .post(cart, this.data)
                .then(() => {
                    if (cleanData) {
                        LocaleStorage.remove(`${storage}client_data`);
                    }
                    document.getElementById('vue-form').submit();
                })
                .catch(data => console.error(data));
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Actions.vue